// Durations, not clock times: hours may exceed 23.
export function parseWipDuration(value) {
  if (!/^\d{2,}:[0-5]\d:[0-5]\d$/.test(value)) return null;
  const [hours, minutes, seconds] = value.split(':').map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}

export function formatWipDuration(value, unit = 'sec') {
  const factors = { sec: 1, second: 1, seconds: 1, min: 60, minute: 60, minutes: 60, hr: 3600, hour: 3600, hours: 3600, day: 86400, days: 86400, 'วินาที': 1, 'นาที': 60, 'ชั่วโมง': 3600, 'วัน': 86400 };
  const seconds = Math.max(0, Math.round(Number(value || 0) * (factors[String(unit).toLowerCase()] || 1)));
  return [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(v => String(v).padStart(2, '0')).join(':');
}
